import { queryOptions } from "@tanstack/react-query";

import { normalizeRequestError } from "@/lib/errors";
import { request } from "@/lib/request";
import { User } from "@/lib/types";

/**
 * Shared key+fn for /user/info so the boot prefetch (main.tsx) and
 * UserProvider's useQuery dedupe into one request. The key carries the
 * session key, never the bearer token, so persisted cache entries hold no
 * credentials.
 */
export const userQueryOptions = (sessionKey: string | null) =>
  queryOptions({
    queryKey: ["user", sessionKey],
    queryFn: async (): Promise<User> => {
      const res = await request
        .get(`/user/info`)
        .catch(normalizeRequestError("Failed to load user profile"));

      return res.data.data;
    },
  });
